(function () {
  'use strict';

  function initNav(root) {
    var track = root.querySelector('[data-collection-category-nav-track]');
    if (!track) return;

    var animationFrameId = null;
    var velocity = 0;
    var lastPosition = 0;
    var lastTime = 0;
    var isDragging = false;

    function adjustInfiniteScroll() {
      var singleSectionWidth = track.scrollWidth / 3;
      var scrollPosition = track.scrollLeft;

      if (scrollPosition < singleSectionWidth) {
        track.scrollLeft += singleSectionWidth;
      } else if (scrollPosition > singleSectionWidth * 2) {
        track.scrollLeft -= singleSectionWidth;
      }
    }

    function applyMomentum() {
      if (!track || Math.abs(velocity) < 0.1) {
        velocity = 0;
        return;
      }

      var currentTime = performance.now();
      var deltaTime = currentTime - lastTime;
      lastTime = currentTime;
      velocity *= Math.pow(0.95, deltaTime / 16);
      track.scrollLeft += velocity * deltaTime;
      adjustInfiniteScroll();
      animationFrameId = requestAnimationFrame(applyMomentum);
    }

    function handleTouchStart(event) {
      if (!event.touches[0]) return;

      isDragging = true;
      lastPosition = event.touches[0].clientX;
      lastTime = performance.now();
      velocity = 0;

      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }
    }

    function handleTouchMove(event) {
      if (!isDragging || !event.touches[0]) return;

      var currentTime = performance.now();
      var deltaTime = currentTime - lastTime;
      var currentPosition = event.touches[0].clientX;
      var deltaX = lastPosition - currentPosition;

      if (deltaTime > 0) {
        velocity = deltaX / deltaTime;
      }

      track.scrollLeft += deltaX;
      adjustInfiniteScroll();
      lastPosition = currentPosition;
      lastTime = currentTime;
    }

    function handleTouchEnd() {
      isDragging = false;

      if (Math.abs(velocity) > 0.1) {
        animationFrameId = requestAnimationFrame(applyMomentum);
      }
    }

    function centerActiveLink() {
      var activeLink = track.querySelector('.collection-category-nav__link--active');
      var singleSectionWidth = track.scrollWidth / 3;

      if (activeLink) {
        requestAnimationFrame(function () {
          var linkLeft = activeLink.offsetLeft;
          var linkWidth = activeLink.offsetWidth;
          var containerWidth = track.clientWidth;
          var targetScrollLeft = linkLeft - containerWidth / 2 + linkWidth / 2;

          if (targetScrollLeft < singleSectionWidth) {
            targetScrollLeft += singleSectionWidth;
          } else if (targetScrollLeft > singleSectionWidth * 2) {
            targetScrollLeft -= singleSectionWidth;
          }

          track.scrollLeft = targetScrollLeft;
        });
      } else {
        track.scrollLeft = singleSectionWidth;
      }
    }

    track.addEventListener('scroll', adjustInfiniteScroll, { passive: true });
    track.addEventListener('touchstart', handleTouchStart, { passive: true });
    track.addEventListener('touchmove', handleTouchMove, { passive: true });
    track.addEventListener('touchend', handleTouchEnd, { passive: true });

    centerActiveLink();
  }

  document.querySelectorAll('[data-collection-category-nav]').forEach(initNav);
})();
